import { Box, Divider, Typography, useTheme } from '@mui/material';
import { generateClient } from 'aws-amplify/api';
import React, { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import { useNavigate } from 'react-router-dom';
import { Schema } from '../../../../amplify/data/resource';
import { useAuth } from '../../../utils/context/useAuthContext';
import EmptyState from './EmptyState';
import PaymentList from './PaymentList/PaymentList';

// @ts-ignore
type AgentPaymentLink = Schema['AgentPaymentLink']['type'];

const apiClient = generateClient<Schema>();

const Dashboard: React.FC = (): JSX.Element => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [activeFilter, setActiveFilter] = useState<string | null>(null);

  const [dialogOpen, setDialogOpen] = useState(false);

  const { user } = useAuth();

  const userId = user?.userId;
  const fullName = user?.name;

  const handleOpenUploadFile = () => {
    navigate('/upload-file');
  };

  const [payments, setPayments] = useState<AgentPaymentLink[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const sub = apiClient.models.AgentPaymentLink.observeQuery({
      filter: { userId: { eq: userId || undefined } },
    }).subscribe({
      next: ({
        items,
        isSynced,
      }: {
        items: AgentPaymentLink[];
        isSynced: boolean;
      }) => {
        setPayments([...items]);
        setLoading(false);
      },
    });
    return () => sub.unsubscribe();
  }, [userId]);

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        gap: '20px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '10px',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <img
            alt="file"
            src={'/assets/header/file.svg'}
            onClick={handleOpenUploadFile}
            style={{ cursor: 'pointer' }}
          />
          <Box
            sx={{
              display: 'flex',
              width: '30%',
              backgroundColor: '#FFF',
              height: '56px',
              borderRadius: '40px',
            }}
          ></Box>
        </Box>
        <Typography
          fontSize="30px"
          fontWeight="700"
          fontFamily={'AlmoniDL'}
          textAlign={'right'}
          sx={{ whiteSpace: 'nowrap' }}
        >
          {fullName} ,שלום
        </Typography>
      </Box>
      <Divider
        sx={{
          width: '100%',
          height: '1px',
          backgroundColor: theme.palette.dark.border,
        }}
      />

      {loading ? (
        <Box sx={{ mt: '100px', display: 'flex', justifyContent: 'center' }}>
          <ReactLoading
            type={'bubbles'}
            color={theme.palette.green.main}
            height={250}
            width={250}
          />
        </Box>
      ) : payments?.length ? (
        <PaymentList payments={payments} />
      ) : (
        <EmptyState />
      )}
    </Box>
  );
};

export default Dashboard;
